import {
  DeviceManifest,
  LIGHTING_EDITABLE_FIELD,
  LIGHTING_EFFECT_KIND,
  LIGHTING_TARGET,
} from '@rapoo/device-sdk'
import {
  itineraryDisabled,
  keyFeaturesDisabled,
  keyboardMacro,
  retailKeyboardConfig,
} from './generate/capabilityPresets'
import { a83airKeys } from './generate/keysGenerate'

/**
 * '', , 0x1905
 **/
const A83_Air_MANIFESTS: DeviceManifest = {
  channel: ['china_game', 'globle'],
  model: 'A83 Air',
  mainControl: 'A83 Air',
  dongleModel: 'Dongle_Telink',
  type: 'keyboard',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x4814, 0x1914],
    currentPid: 0x4814,
    transport: 'HID',
    filters: [
      {
        usagePage: 0xff00,
        usage: 14,
        description: 'aesco A83 Air Telink 控制接口',
        type: 'default',
      },
      {
        usagePage: 0xffef,
        usage: 0,
        description: 'aesco A83 Air Telink 固件升级接口',
        type: 'update',
      },
    ],
  },
  driver: 'TelinkKeyboard',
  MCU: 'Telink',
  ui: {
    assetsDir: 'manifests/A83 Air',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.A83_Air.Glass_Blue',
          value: '#F2F2F2',
          key: 'Glass_Blue',
        },
      ],
      current: 'Glass_Blue',
    },
    // 小图标
    icon: 'Hardware-Wireframe-Keyboard',
    // 是否支持设备概览
    overview: true,
  },
  capabilities: [
    retailKeyboardConfig,
    {
      type: 'lighting',
      config: {
        enable: true,
        backlightSwitch: true,
        tabI18nKeys: {
          [LIGHTING_TARGET.Side]: 'lighting.tabs.statusIsland',
        },
        effects: [
          {
            id: 100,
            i18nKey: 'lighting.effect.wave_flow',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
          },
          {
            id: 101,
            i18nKey: 'lighting.effect.colorful_raindrop_falling',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
          },
          {
            id: 102,
            i18nKey: 'lighting.effect.breathing',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.Color,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
          },
          {
            id: 103,
            i18nKey: 'lighting.effect.stars_twinkle',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.Color,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
          },
          {
            id: 104,
            i18nKey: 'lighting.effect.ripple',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
          },
          {
            id: 105,
            i18nKey: 'lighting.effect.swiftly',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
              LIGHTING_EDITABLE_FIELD.Color,
            ],
          },
          {
            id: 106,
            i18nKey: 'lighting.effect.sudden_turn',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
          },
          {
            id: 107,
            i18nKey: 'lighting.effect.great_winged',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
          },
          {
            id: 108,
            i18nKey: 'lighting.effect.seeking_plum_blossoms',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
              LIGHTING_EDITABLE_FIELD.Color,
            ],
          },
          {
            id: 109,
            i18nKey: 'lighting.effect.snap',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
              LIGHTING_EDITABLE_FIELD.Color,
            ],
          },
          {
            id: 110,
            i18nKey: 'lighting.effect.click_diffusion',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
              LIGHTING_EDITABLE_FIELD.Color,
            ],
          },
          {
            id: 111,
            i18nKey: 'lighting.effect.twinkling_stars',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
          },
          {
            id: 0,
            i18nKey: 'lighting.effect.rgb_constant',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Static,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.ColorCycle,
            ],
            staticType: 1,
          },
          {
            id: 1,
            i18nKey: 'lighting.effect.blue_sky_white_clouds',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Static,
            editableFields: [LIGHTING_EDITABLE_FIELD.Brightness],
            staticType: 1,
          },
          {
            id: 2,
            i18nKey: 'lighting.effect.row_gradient',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Static,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Color,
              LIGHTING_EDITABLE_FIELD.Gradient,
            ],
            staticType: 3,
          },
          {
            id: 3,
            i18nKey: 'lighting.effect.col_gradient',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Static,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Color,
              LIGHTING_EDITABLE_FIELD.Gradient,
            ],
            staticType: 2,
          },
          {
            id: 4,
            i18nKey: 'lighting.effect.moba',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Static,
            editableFields: [LIGHTING_EDITABLE_FIELD.Brightness],
            staticType: 1,
          },
          {
            id: 5,
            i18nKey: 'lighting.effect.fps',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Static,
            editableFields: [LIGHTING_EDITABLE_FIELD.Brightness],
            staticType: 1,
          },
          {
            id: 6,
            i18nKey: 'lighting.effect.car',
            target: LIGHTING_TARGET.Keyboard,
            kind: LIGHTING_EFFECT_KIND.Static,
            editableFields: [LIGHTING_EDITABLE_FIELD.Brightness],
            staticType: 1,
          },
          {
            id: 0,
            i18nKey: 'lighting.effect.static',
            target: LIGHTING_TARGET.Side,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [LIGHTING_EDITABLE_FIELD.Brightness, LIGHTING_EDITABLE_FIELD.Color],
          },
          {
            id: 1,
            i18nKey: 'lighting.effect.rgb_flow',
            target: LIGHTING_TARGET.Side,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [
              LIGHTING_EDITABLE_FIELD.ColorCycle,
              LIGHTING_EDITABLE_FIELD.Brightness,
              LIGHTING_EDITABLE_FIELD.Speed,
            ],
          },
          {
            id: 2,
            i18nKey: 'lighting.effect.static_breathing',
            target: LIGHTING_TARGET.Side,
            kind: LIGHTING_EFFECT_KIND.Dynamic,
            editableFields: [LIGHTING_EDITABLE_FIELD.Brightness, LIGHTING_EDITABLE_FIELD.Color],
          },
        ],
      },
    },
    itineraryDisabled,
    keyFeaturesDisabled,
    {
      type: 'keyboardPerf',
      config: {
        macMode: true,
        reportRateOptions: [
          { value: 0x08, label: '125Hz' },
          { value: 0x04, label: '250Hz' },
          { value: 0x02, label: '500Hz' },
          { value: 0x01, label: '1000Hz' },
        ],
        sleepTimeRange: { min: 2, max: 120 },
      },
    },
    {
      type: 'keys',
      config: a83airKeys,
    },
    keyboardMacro,
  ],
  layout: {
    image: 'frame',
    top: 18,
    bottom: 16,
    left: 16,
    right: 16,
    unit: 40,
    keys: [
      [
        {
          key: 0,
          keywords: 'Esc',
        },
        {
          key: 1,
          keywords: 'F1',
        },
        {
          key: 2,
          keywords: 'F2',
        },
        {
          key: 3,
          keywords: 'F3',
        },
        {
          key: 4,
          keywords: 'F4',
        },
        {
          key: 5,
          keywords: 'F5',
        },
        {
          key: 6,
          keywords: 'F6',
        },
        {
          key: 7,
          keywords: 'F7',
        },
        {
          key: 8,
          keywords: 'F8',
        },
        {
          key: 9,
          keywords: 'F9',
        },
        {
          key: 10,
          keywords: 'F10',
        },
        {
          key: 11,
          keywords: 'F11',
        },
        {
          key: 12,
          keywords: 'F12',
        },
        {
          key: 13,
          keywords: 'PrintScreen',
        },
        {
          key: 14,
          keywords: 'Insert',
        },
        {
          key: 80,
          keywords: 'Delete',
        },
      ],
      [
        {
          key: 22,
          keywords: '~_`',
        },
        {
          key: 23,
          keywords: '!_1',
        },
        {
          key: 24,
          keywords: '@_2',
        },
        {
          key: 25,
          keywords: '#_3',
        },
        {
          key: 26,
          keywords: '$_4',
        },
        {
          key: 27,
          keywords: '%_5',
        },
        {
          key: 28,
          keywords: '^_6',
        },
        {
          key: 29,
          keywords: '&_7',
        },
        {
          key: 30,
          keywords: '*_8',
        },
        {
          key: 31,
          keywords: '(_9',
        },
        {
          key: 32,
          keywords: ')_0',
        },
        {
          key: 33,
          keywords: '__-',
        },
        {
          key: 34,
          keywords: '+_=',
        },
        {
          key: 35,
          keywords: 'BackSpace',
          w: 2,
        },
        {
          key: 36,
          keywords: 'Home',
        },
      ],
      [
        {
          key: 44,
          keywords: 'Tab',
          w: 1.5,
        },
        {
          key: 45,
          keywords: 'Q',
        },
        {
          key: 46,
          keywords: 'W',
        },
        {
          key: 47,
          keywords: 'E',
        },
        {
          key: 48,
          keywords: 'R',
        },
        {
          key: 49,
          keywords: 'T',
        },
        {
          key: 50,
          keywords: 'Y',
        },
        {
          key: 51,
          keywords: 'U',
        },
        {
          key: 52,
          keywords: 'I',
        },
        {
          key: 53,
          keywords: 'O',
        },
        {
          key: 54,
          keywords: 'P',
        },
        {
          key: 55,
          keywords: '{_[',
        },
        {
          key: 56,
          keywords: '}_]',
        },
        {
          key: 57,
          keywords: '|_\\',
          w: 1.5,
        },
        {
          key: 58,
          keywords: 'End',
        },
      ],
      [
        {
          key: 66,
          keywords: 'CapsLock',
          w: 1.75,
        },
        {
          key: 67,
          keywords: 'A',
        },
        {
          key: 68,
          keywords: 'S',
        },
        {
          key: 69,
          keywords: 'D',
        },
        {
          key: 70,
          keywords: 'F',
        },
        {
          key: 71,
          keywords: 'G',
        },
        {
          key: 72,
          keywords: 'H',
        },
        {
          key: 73,
          keywords: 'J',
        },
        {
          key: 74,
          keywords: 'K',
        },
        {
          key: 75,
          keywords: 'L',
        },
        {
          key: 76,
          keywords: ':_;',
        },
        {
          key: 77,
          keywords: '"_\'',
        },
        {
          key: 78,
          keywords: 'Enter',
          w: 2.25,
        },
        {
          key: 79,
          keywords: 'PgUp',
        },
      ],
      [
        {
          key: 88,
          keywords: 'Shift_L',
          w: 2.25,
        },
        {
          key: 90,
          keywords: 'Z',
        },
        {
          key: 91,
          keywords: 'X',
        },
        {
          key: 92,
          keywords: 'C',
        },
        {
          key: 93,
          keywords: 'V',
        },
        {
          key: 94,
          keywords: 'B',
        },
        {
          key: 95,
          keywords: 'N',
        },
        {
          key: 96,
          keywords: 'M',
        },
        {
          key: 97,
          keywords: '<_,',
        },
        {
          key: 98,
          keywords: '>_.',
        },
        {
          key: 99,
          keywords: '?_/',
        },
        {
          key: 100,
          keywords: 'Shift_R',
          w: 1.75,
        },
        {
          key: 101,
          keywords: '↑',
        },
        {
          key: 102,
          keywords: 'PgDn',
        },
      ],
      [
        {
          key: 110,
          keywords: 'Ctrl_L',
          w: 1.25,
        },
        {
          key: 111,
          keywords: 'Win_L',
          w: 1.25,
        },
        {
          key: 112,
          keywords: 'Alt_L',
          w: 1.25,
        },
        {
          key: 113,
          keywords: 'Space_L',
          w: 6.25,
        },
        {
          key: 119,
          keywords: 'Fn',
          w: 1.25,
        },
        {
          key: 121,
          keywords: 'Ctrl_R',
          w: 1.25,
        },
        {
          key: 122,
          keywords: '←',
          x: 0.5,
        },
        {
          key: 123,
          keywords: '↓',
        },
        {
          key: 124,
          keywords: '→',
        },
      ],
    ],
  },
}

export default A83_Air_MANIFESTS
